module.exports = __webpack_public_path__ + "static/media/Approved.f96d3c64.svg";